<template>
  <div class="fullWidth fRow jStart aCenter">
    <span v-if="!deleteMode && loaded">{{indexs + 1}}</span>
    <div class="fRow jStart aCenter growFull" v-if="!deleteMode && loaded">
      <input type="text" class="editable fullWidth"
        :disabled="!editMode"
        v-model="name"
        :placeholder="data.title">
      <i class="material-icons-round transition-fast"
        v-if="editMode === false"
        @click="editMode = true">edit</i>
      <i class="material-icons-round red transition-fast"
        v-if="editMode === false"
        @click="deleteMode = true">delete</i>
      <i class="material-icons-round transition-fast"
        v-bind:class="{green: canSave}"
        v-if="editMode === true"
        @click="editClassification">save</i>
      <i class="material-icons-round transition-fast"
        v-if="editMode === true"
        @click="editMode = false">close</i>
    </div>
    <div class="deleteDialoge fRow jStart aCenter fullWidth"
      v-if="deleteMode && !loading">
      <span class="growFull">آیا از حذف آیتم مطمئنید؟</span>
      <i class="red material-icons-round" @click="deleteClassification">delete</i>
      <i class="material-icons-round"
        @click="deleteMode = false">close</i>
    </div>
    <div class="fRow jCenter aCenter fullWidth"
      style="padding: 16px 0"
      v-if="loading">
      <p-bar
        :loading="loading"
        :mini="true"
        :notYet="notYet"
        :noContent="noContent"
        :notFound="notFound"
        :error="error" />
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import pBar from '@/components/pBar.vue';
import errorHandler from '@/mixins/mixin';
import makeToast from '@/mixins/makeToast';

export default {
  props: ['data', 'indexs'],
  mixins: [errorHandler, makeToast],
  data() {
    return {
      baseURL: this.$store.state.baseUrl,
      V: this.$store.state.apiVersion,
      editMode: false,
      deleteMode: false,
      // modes ↓
      loading: false,
      noContent: false,
      notFound: false,
      error: false,
      notYet: false,
      loaded: true,
      modeMsg: '',
      // modes ↑
      name: '',
    };
  },
  methods: {
    editClassification() {
      if (this.canSave) {
        this.setMode('loading');
        const reqUrl = `${this.baseURL}/api/v${this.V}/Questions/classification/${this.data.id}`;
        axios({
          method: 'put',
          url: reqUrl,
          headers: {
            Authorization: this.$authObeject.authToken(),
          },
          data: {
            name: this.name,
          },
        }).then((response) => {
          if (response.data.isSuccess) {
            this.setMode('loaded');
          } else {
            this.setMode('loaded');
            this.makeToast('error', 'مشکلی پیش آمده، دوباره تلاش کنید', 3000);
          }
          this.$emit('refresh');
          this.editMode = false;
        }, (error) => {
          this.makeToast('error', this.errorHandler(error), 3000);
          this.editMode = false;
          // console.log(error);
        }).catch(() => {
          this.makeToast('error', 'در صورت درستی اتصال به اینترنت، با تیم فنی تماس بگیرید', 3000);
          this.editMode = false;
        });
      } else {
        this.makeToast('error', 'ابتدا نام طبقه بندی را ویرایش کنید', 3000);
      }
    },
    deleteClassification() {
      if (true) {
        this.setMode('loading');
        const reqUrl = `${this.baseURL}/api/v${this.V}/Questions/classification/${this.data.id}`;
        axios({
          method: 'delete',
          url: reqUrl,
          headers: {
            Authorization: this.$authObeject.authToken(),
          },
        }).then((response) => {
          if (response.data.isSuccess) {
            this.setMode('loaded');
          } else {
            this.setMode('loaded');
            this.makeToast('error', 'مشکلی پیش آمده، دوباره تلاش کنید', 3000);
          }
          this.$emit('refresh');
          this.deleteMode = false;
        }, (error) => {
          this.makeToast('error', this.errorHandler(error), 3000);
          this.setMode('loaded');
          this.deleteMode = false;
          // console.log(error);
        }).catch(() => {
          this.makeToast('error', 'در صورت درستی اتصال به اینترنت، با تیم فنی تماس بگیرید', 3000);
          this.setMode('loaded');
          this.deleteMode = false;
        });
      }
    },
    setMode(m, msg) {
      this.noContent = false;
      this.loading = false;
      this.notYet = false;
      this.error = false;
      this.loaded = false;
      this.modeMsg = '';
      switch (m) {
        case 'loading': {
          this.loading = true;
          break;
        }
        case 'loaded': {
          this.loaded = true;
          break;
        }
        case 'error': {
          this.modeMsg = msg;
          this.error = true;
          break;
        }
        case 'notYet': {
          this.notYet = true;
          break;
        }
        case 'noContent': {
          this.noContent = true;
          break;
        }
        default:
          break;
      }
    },
  },
  components: {
    pBar,
  },
  watch: {
    editMode() {
      if (this.editMode) {
        this.name = this.data.title;
      } else {
        this.name = '';
      }
    },
  },
  computed: {
    canSave() {
      return this.name !== '' && this.name !== this.data.title;
    },
  },
  mounted() {
    this.$nextTick(() => {
      // this.name = this.data.title;
    });
  },
};
</script>

<style lang="scss" scoped>
input:disabled {
  background-color: rgba($color: #000000, $alpha: 0);
  border-bottom: solid 1px rgba($color: #000000, $alpha: 0.0);
}
input {
  border-width: 0;
  outline: none;
  padding: 8px 0;
  margin-right: 16px;
  border-bottom: solid 1px rgba($color: #000000, $alpha: 0.15);
}
input:focus {
  border-bottom: solid 1px rgba($color: #000000, $alpha: 0.25);
}
.deleteDialoge {
  border: solid 2px rgba($color: red, $alpha: 1.0);
  padding: 8px;
  border-radius: 24px 8px 8px 24px;
}
::placeholder {
  color: #131313;
  opacity: 1; /* Firefox */
}
:-ms-input-placeholder { /* Internet Explorer 10-11 */
  color: #131313;
}
::-ms-input-placeholder { /* Microsoft Edge */
  color: #131313;
}
i {
  font-size: 16px;
  cursor: pointer;
  padding: 8px;
  border-radius: 50%;
  background-color: rgba($color: #000000, $alpha: 0.02);
  color: #343434;
  margin-right: 8px;
}
i.red {
  background-color: rgba($color: rgb(201, 44, 44), $alpha: 1) !important;
  color: #ececec !important;
}
i.green {
  background-color: rgba($color: rgb(74, 141, 54), $alpha: 1) !important;
  color: #ececec !important;
}
i:hover {
  box-shadow: 0 0 0 2px rgba($color: #000000, $alpha: 0.25);
}
</style>
